import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ViewWrapper } from './view-wrapper.component';
import CustomButton from '../react-native-material-wrapper/button.component';
import { getTheme } from '../../stores/selectors/theme.selector';
import { useSelector } from 'react-redux';
import errorimg from '../../assets/images/charger/error.svg';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetErrorBoundary }) => {
  const { i18n } = useTranslation();

  const theme = useSelector(getTheme);

  const handleReload = () => {
    window.location.reload();
  };

  const callSupport = () => {
    window.location.href = `tel:1-800-636-0986`;
  };

  return (
    <ViewWrapper>
      <div
        style={{
          textAlign: 'center',
          display: 'block',
          alignContent: 'center',
          padding: '24px 16px 0px 16px',
        }}
      >
        <img src={errorimg} alt='errorimg' width={240} height={260} />
        <Typography
          variant='h5'
          style={{
            width: '100%',
            display: 'inline-block',
            marginBottom: '16px',
            marginTop: '24px',
            fontFamily: 'Inter',
            fontWeight: 600,
            fontSize: '20px',
            lineHeight: '28px',
            color: '#202223',
          }}
        >
          {i18n.t('oops')} {i18n.t('something_went_wrong')}
        </Typography>
        <Typography
          style={{
            width: '100%',
            display: 'inline-block',
            fontSize: '16px',
            fontWeight: '400',
            lineHeight: '24px',
            fontFamily: 'Inter',
            marginBottom: '24px',
            color: '#202223',
          }}
        >
          {i18n.t('something_went_wrong_description')}
        </Typography>

        {process.env.NODE_ENV === 'development' && (
          <Box
            style={{
              margin: '16px 0',
              padding: '12px',
              backgroundColor: '#f5f5f5',
              borderRadius: '8px',
              textAlign: 'left',
            }}
          >
            <Typography
              variant='caption'
              component='pre'
              style={{
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                fontSize: '0.75rem',
                fontFamily: 'monospace',
              }}
            >
              {error.toString()}
            </Typography>
          </Box>
        )}

        <Box style={{ marginBottom: '24px' }}>
          <CustomButton
            size='large'
            style={{
              backgroundColor: theme.primary,
              color: 'white',
              fontSize: '14px',
              fontWeight: 500,
              lineHeight: '20px',
              fontFamily: 'Inter',
              textTransform: 'inherit',
              marginRight: '12px',
              padding: '12px 24px',
            }}
            onClick={resetErrorBoundary}
          >
            Try Again
          </CustomButton>
          <CustomButton
            size='large'
            style={{
              border: `1px solid ${theme.primary}`,
              color: theme.primary,
              backgroundColor: 'transparent',
              fontSize: '14px',
              fontWeight: 500,
              lineHeight: '20px',
              fontFamily: 'Inter',
              textTransform: 'inherit',
              padding: '12px 24px',
            }}
            onClick={handleReload}
          >
            Reload Page
          </CustomButton>
        </Box>

        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            height: '26px',
            alignItems: 'center',
          }}
        >
          <Typography
            variant='h6'
            style={{
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: '500',
              lineHeight: '20px',
              textAlign: 'center',
              color: '#4E5968',
            }}
          >
            {i18n.t('still_having_trouble')}
          </Typography>
          <CustomButton
            size='large'
            style={{
              color: theme.primary,
              fontSize: '14px',
              fontWeight: 500,
              lineHeight: '20px',
              letterSpacing: '0em',
              textAlign: 'center',
              fontFamily: 'Inter',
              textTransform: 'inherit',
              paddingLeft: '4px',
            }}
            onClick={callSupport}
          >
            {i18n.t('Call_support')}
          </CustomButton>
        </Box>
      </div>
    </ViewWrapper>
  );
};
